// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Review_wrap__3g76a","quote":"Review_quote__1W0c7","author":"Review_author__3VsTU"};